module.exports = __webpack_public_path__ + "media/images/svg/clients/3-bc0f084bdfdba250ec4d9a727aeeac32.svg";